<form [formGroup]="contractForm" (ngSubmit)="onSubmit()">
  <mat-card class="mat-card-contract-detail mat-card-contract-detail-info">
    <mat-card-header>
      <mat-card-title>{{ 'customer.contract-creation' | translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="mat-card-content-contract-detail">
      <div class="content-row">
        <label class="content-row-label">{{ 'label.site' | translate}}</label>
        <app-site-list [control]="$any(contractForm).controls['site']" class="content-row-input" [pacoOnly]="true">
        </app-site-list>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'label.type' | translate }}</label>
        <mat-radio-group aria-label="Select an option" formControlName="contractTypeId" class="content-row-input">
          <mat-radio-button *ngFor="let contractType of contractTypes" [value]="contractType.id">{{ 'contract.' +
            contractType.name | translate}}</mat-radio-button>
        </mat-radio-group>
      </div>

      <!-- <div class="content-row"
        *ngIf="selectedContractType == ContractType.termConcession || selectedContractType == ContractType.precariousConcession">
        <label class="content-row-label">{{ 'contract.zone-type' | translate}}</label>
        <mat-radio-group aria-label="Select an option" formControlName="zone" class="content-row-input">
          <mat-radio-button value="A">{{ 'contract.zone-a' | translate}}</mat-radio-button>
          <mat-radio-button value="B">{{ 'contract.zone-b' | translate}}</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="content-row"
        *ngIf="selectedContractType == ContractType.termConcession || selectedContractType == ContractType.precariousConcession">
        <label class="content-row-label">{{ 'contract.fittedOutArea' | translate}}</label>
        <mat-radio-group aria-label="Select an option" formControlName="isFittedOutArea" class="content-row-input">
          <mat-radio-button value="true">{{ 'button.yes' | translate}}</mat-radio-button>
          <mat-radio-button value="false">{{ 'button.no' | translate}}</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="content-row"
        *ngIf="selectedContractType == ContractType.termConcession || selectedContractType == ContractType.precariousConcession">
        <label class="content-row-label">{{ 'contract.accessibility' | translate}}</label>
        <mat-radio-group aria-label="Select an option" formControlName="isGoodAccessibility" class="content-row-input">
          <mat-radio-button value="true">{{ 'contract.accessibility-good' | translate}}</mat-radio-button>
          <mat-radio-button value="false">{{ 'contract.accessibility-bad' | translate}}</mat-radio-button>
        </mat-radio-group>
      </div> -->

      <div class="content-row" *ngIf="selectedContractType == ContractType.publicDock">
        <label class="content-row-label">{{ 'contract.handling' | translate}}</label>
        <mat-radio-group aria-label="Select an option" formControlName="isPunctualHandling" class="content-row-input">
          <mat-radio-button value="false">{{ 'contract.handling-permanent' | translate}}</mat-radio-button>
          <mat-radio-button value="true">{{ 'contract.handling-punctual' | translate}}</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'label.beginDate' | translate}}</label>
        <mat-form-field class="content-row-input">
          <input matInput [matDatepicker]="startDateContract" formControlName="dateBegin" autocomplete="off"
            [max]="contractForm.get('dateEnd')?.value">
          <mat-datepicker-toggle matSuffix [for]="startDateContract"></mat-datepicker-toggle>
          <mat-datepicker #startDateContract [disabled]="contractForm.get('dateBegin')?.disabled"></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'label.endDate' | translate}}</label>
        <mat-form-field class="content-row-input">
          <input matInput [matDatepicker]="endDateContract" formControlName="dateEnd" autocomplete="off"
            [min]="contractForm.get('dateBegin')?.value">
          <mat-datepicker-toggle matSuffix [for]="endDateContract"></mat-datepicker-toggle>
          <mat-datepicker #endDateContract [disabled]="contractForm.get('dateEnd')?.disabled"></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="content-row" *ngIf="(selectedContractType != ContractType.publicDock) || (contractForm.controls.isPunctualHandling.value == 'false')">
        <label class="content-row-label">{{ 'label.min-tonnage-annual' | translate}}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="quantityMin" type="number" autocomplete="off">
          <span matSuffix>{{ 'label.tonne(s)' | translate}}</span>
        </mat-form-field>
      </div>
    </mat-card-content>

    <mat-card-actions class="contract-creation-card-action">
      <button mat-raised-button color="warn" type="button" (click)="onCancel()">
        <mat-icon>clear</mat-icon> {{ 'button.cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="contractForm.invalid">
        <mat-icon>save</mat-icon> {{ 'button.save' | translate }}
      </button>
    </mat-card-actions>

  </mat-card>
</form>